import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import { StatCard } from '../../common';

/** KPI tile for the console summary; clicking it jumps to the related tab. */
export default function AuditKpiCard({ title, value, tone = 'brand', icon, current, prior, onClick }) {
    let trend = null;
    if (current !== undefined && prior !== undefined) {
        const diff = current - prior;
        if (diff > 0) {
            trend = (
                <span className="inline-flex items-center gap-1 text-success-fg">
                    <ArrowUp /> +{diff} vs 7d anterior
                </span>
            );
        } else if (diff < 0) {
            trend = (
                <span className="inline-flex items-center gap-1 text-danger-fg">
                    <ArrowDown /> {diff} vs 7d anterior
                </span>
            );
        } else {
            trend = (
                <span className="inline-flex items-center gap-1 text-surface-400">
                    <Minus /> Sin cambio
                </span>
            );
        }
    }

    return <StatCard label={title} value={value} icon={icon} tone={tone} hint={trend} onClick={onClick} />;
}
